import React from 'react';
import { Row, Col, Select, Button, Input, Affix } from 'antd';
import { isMobile } from 'react-device-detect';
import DropDownComp from '../../components/DropDown';
import PointsDisplay from '../../../AdminPortal/components/AgentPoints/AgentPoints';

const { Search } = Input;
const { Option } = Select;

const FilterHeader = ({
  handleSearch,
  handleFilterChange,
  setValue,
  setSliderValue,
  value,
  selectedCategory,
  categoryHandleMultiple,
  categoryOption,
  handleReshuffle,
  agentPoints,
  searchState
}) => {
  return (
    <Affix offsetTop={62} style={{zIndex: 9999}}>
      <div style={{
        background: 'white',
        padding: isMobile ? '14px' : '24px 12px',
        borderBottom: '1px solid #f0f0f0',
        zIndex: 1100,
        top: 0
      }}>
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col flex="auto">
            <Row gutter={[16, 16]} align="middle">
              <Col style={{ minWidth: 200, maxWidth: 300 }}>
              <Search
                placeholder="Search Rewards..."
                allowClear
                enterButton="Search"
                size="large"
                defaultValue={searchState}
                onSearch={handleSearch}
                style={{ width: '100%' }}
              />
              </Col>
              
              {!isMobile ? (
                <>
                  <Col style={{ width: 150, marginRight: 0 }}>
                    <Select
                      size="large"
                      defaultValue="Randomize"
                      style={{ width: '100%' }}
                      onChange={handleFilterChange}
                      options={[
                        { value: "1", label: "Randomize" },
                        { value: "2", label: "Popular" },
                        { value: "3", label: "Featured" },
                        { value: "4", label: "Newest" },
                        { value: "5", label: "Oldest" },
                        { value: "6", label: "Points Ascending" },
                        { value: "7", label: "Points Descending" },
                      ]}
                    />
                  </Col>
                  <Col style={{ width: 200, marginRight: 8 }}>
                    <DropDownComp
                      setValue={setValue}
                      setSliderValue={setSliderValue}
                      value={value}
                    />
                  </Col>
                  <Col style={{ width: 300, marginRight: 0 }}>
                    <Select
                      placeholder="Select Categories"
                      allowClear
                      value={selectedCategory}
                      mode="multiple"
                      size="large"
                      style={{ width: '100%' }}
                      onChange={(value) => categoryHandleMultiple(value)}
                      showSearch={false}
                      maxTagCount="responsive"
                    >
                      {categoryOption.map((item) => (
                        <Option key={item.value} value={item.value}>
                          <div style={{ display: "flex", justifyContent: "start" }}>
                            <span>{item.label}</span>
                          </div>
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col>
                    <Button 
                      size="large"
                      onClick={handleReshuffle}
                      type="primary"
                      style={{ height: 40 }}
                    >
                      Reshuffle List
                    </Button>
                  </Col>
                </>
              ) : (
                <>
                  <Col span={24}>
                    <Select
                      size="large"
                      defaultValue="Default"
                      style={{ width: '100%' }}
                      onChange={handleFilterChange}
                      options={[
                        { value: "1", label: "Default" },
                        { value: "2", label: "Popular" },
                        { value: "3", label: "Featured" },
                        { value: "4", label: "Newest" },
                        { value: "5", label: "Oldest" },
                        { value: "6", label: "Points Ascending" },
                        { value: "7", label: "Points Descending" },
                      ]}
                    />
                  </Col>
                  <Col span={24}>
                    <DropDownComp
                      setValue={setValue}
                      setSliderValue={setSliderValue}
                      value={value}
                    />
                  </Col>
                </>
              )}
            </Row>
          </Col>
          <Col>
            <PointsDisplay points={agentPoints} />
          </Col>
        </Row>
      </div>
    </Affix>
  );
};

export default FilterHeader;